(function () {
  const grid = document.querySelector('.collection .product-grid');
  const paginationEl = document.querySelector('.pagination');

  if (!grid) return;

  // Hide pagination
  if (paginationEl) paginationEl.style.display = 'none';

  let currentPage = 1;
  let isLoading = false;
  let exhausted = false;

  // Spinner
  const spinner = document.createElement('div');
  spinner.innerHTML = '<span style="display:inline-block;width:24px;height:24px;border:2px solid currentColor;border-top-color:transparent;border-radius:50%;animation:spin .7s linear infinite;opacity:.5"></span>';
  spinner.style.cssText = 'text-align:center;padding:24px;display:none';
  grid.after(spinner);

  const style = document.createElement('style');
  style.textContent = '@keyframes spin{to{transform:rotate(360deg)}}';
  document.head.appendChild(style);

  async function loadNextPage() {
    if (isLoading || exhausted) return;

    isLoading = true;
    spinner.style.display = 'block';
    currentPage++;

    try {
      const url = new URL(window.location.href);
      url.searchParams.set('page', currentPage);

      const res = await fetch(url.toString());
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newProducts = doc.querySelectorAll('.collection .product-grid > *');

      if (newProducts.length === 0) {
        // No products came back — we've reached the end
        exhausted = true;
        spinner.style.display = 'none';
        return;
      }

      newProducts.forEach(item => grid.appendChild(item.cloneNode(true)));

      // If the fetched page has no pagination "next" link, this was the last page
      const fetchedPagination = doc.querySelector('.pagination');
      const hasNextPage = fetchedPagination
        ? !!fetchedPagination.querySelector('a[aria-label="Next page"], a[href*="page="]')
        : false;

      if (!hasNextPage) exhausted = true;

    } catch (e) {
      console.error('Infinite scroll error:', e);
      currentPage--; // allow retry on next scroll
    } finally {
      isLoading = false;
      if (!exhausted) spinner.style.display = 'none';
    }
  }

  window.addEventListener('scroll', () => {
    if (exhausted || isLoading) return;
    const scrolled = window.scrollY + window.innerHeight;
    const threshold = document.documentElement.scrollHeight - 1200;
    if (scrolled >= threshold) loadNextPage();
  }, { passive: true });
})();